import type { TGetEmpreendimentoMidiaResponse } from '@/features/empreendimentos/shared/types/empreendimento'
import { HttpService } from '@/infra/http'

export class GetEmpreendimentoFotosService extends HttpService {
  execute = async (idExterno: number) => {
    return this.http.get<TGetEmpreendimentoMidiaResponse>(`api/v2/Empreendimento/${idExterno}/fotos`)
  }
}
